{{ category | safeCategory | titlecase }}
